import { render, staticRenderFns } from "./WickConfigurator.vue?vue&type=template&id=01edd6e7&scoped=true"
import script from "./WickConfigurator.vue?vue&type=script&lang=js"
export * from "./WickConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01edd6e7",
  null
  
)

export default component.exports